import React from "react";
type MenuPanelProps = {
  children: React.ReactNode;
};

/** Blue mega-menu surface with the site's angled navy bottom edge. */
export function MenuPanel({
  children
}: MenuPanelProps) {
  return <div className="relative bg-i9-blue pb-14 text-white shadow-[0_24px_48px_-16px_rgba(22,21,74,0.55)]" data-id="element-86" data-mp="ka37ttwl6vol">
      {children}
      <div className="absolute bottom-0 left-0 right-0 h-8 bg-i9-ink" style={{
      clipPath: "polygon(35% 100%, 100% 20%, 100% 100%)"
    }} aria-hidden="true" data-id="element-87" data-mp="p9fxsnir8ive" />
    </div>;
}
export function MenuHeading({
  children
}: {
  children: React.ReactNode;
}) {
  return <h3 className="font-display text-lg font-extrabold uppercase italic tracking-wider" data-id="element-88" data-mp="13yc0s65yf5p5">{children}</h3>;
}